module.exports = __webpack_public_path__ + "static/img/portrait.ee21ddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attestation/portrait.png
// module id = +m+P
// module chunks = 1